define('app/sf/prefix/sf-prefix-filter',[],function () {
	return function sfPrefixFilter(value, prefix) {
		if (value) {
			return prefix + "" + value;
		}
		else {
			return "";
		}
	};
});
